/// <amd-module name="Build/Admin/Common/Services/HeaderBreadcrumbService" />
import { TaskAgent, TaskAgentPool, TaskAgentQueue } from "DistributedTask/Client/Contracts/TaskAgent";

import { IBreadcrumbItemService } from "VSS/Features/PlatformUI/ContributedBreadcrumb";
import { IBreadcrumbItem } from "VSSUI/Breadcrumb.Types";

import { IReadonlyObservableArray, ObservableArray } from "VSS/Core/Observable";
import { Services, VssService } from "VSS/Platform/Context";
import { onClickFPS } from "VSS/Platform/FPS";

import { ServiceIds } from "Build/Admin/Common/Constants";
import { IPoolAdminLinkingService } from "Build/Admin/Common/Services/PoolAdminLinkingService";

export interface IPoolAdminBreadcrumbData {
    agent: TaskAgent | undefined;
    agentQueue: TaskAgentQueue | undefined;
    agentPool: TaskAgentPool | undefined;
}

export class HeaderBreadcrumbService extends VssService implements IBreadcrumbItemService {

    private items = new ObservableArray<IBreadcrumbItem>();

    public getBreadcrumbItems(breadcrumbId: string): IReadonlyObservableArray<IBreadcrumbItem> {
        return this.items;
    }

    public refresh(data: IPoolAdminBreadcrumbData): void {
        this.items.removeAll();

        const linkingService = this.pageContext.getService<IPoolAdminLinkingService>("IPoolAdminLinkingService");

        if (data.agentQueue) {
            const agentQueueLink: string = linkingService.getAgentQueueUrl(data.agentQueue);
            this.items.push({
                key: "agentQueue",
                text: data.agentQueue.name,
                href: agentQueueLink,
                onClick: (ev) => {
                    this._onFPSClick(agentQueueLink, ev);
                }
            });

            if (data.agent) {
                const agentLink: string = linkingService.getAgentUrl(data.agentQueue, undefined, data.agent);
                this.items.push({
                    key: "agent",
                    text: data.agent.name,
                    href: agentLink,
                    onClick: (ev) => {
                        this._onFPSClick(agentLink, ev);
                    }
                });
            }
        }
        else if (data.agentPool) {
            const agentPoolLink: string = linkingService.getAgentPoolUrl(data.agentPool);
            this.items.push({
                key: "agentPool",
                text: data.agentPool.name,
                href: agentPoolLink,
                onClick: (ev) => {
                    this._onFPSClick(agentPoolLink, ev);
                }
            });

            if (data.agent) {
                const agentLink: string = linkingService.getAgentUrl(undefined, data.agentPool, data.agent);
                this.items.push({
                    key: "agent",
                    text: data.agent.name,
                    href: agentLink,
                    onClick: (ev) => {
                        this._onFPSClick(agentLink, ev);
                    }
                });
            }
        }
    }

    private _onFPSClick = (link: string, ev?: React.MouseEvent<HTMLElement>) => {
        onClickFPS(this.pageContext, link, true, ev, { telemetrySource: "pools-admin-breadcrumb" });
    }
}

Services.add(ServiceIds.HeaderBreadcrumbService, { serviceFactory: HeaderBreadcrumbService });
